import { GoabFormItem } from "@abgov/react-components";
import MPPTextArea from "../../../components/textarea/MPPTextArea";

const MAX_CHARS = 400;

export const ManualAddress = ({ form, getResourceValue, handleChange }) => {
    const locationError = form.errors.location && getResourceValue({ key: form.errors.location });

    return (
        <GoabFormItem
            label={getResourceValue({ key: "RESOURCES@form.location.label" })}
            helpText={getResourceValue({ key: "RESOURCES@form.location.helpText" })}
            error={locationError}
            id="location"
        >
            <MPPTextArea
                name="location"
                defaultValue={form.values.location ?? ''}
                maxLength={MAX_CHARS}
                rows={4}
                error={locationError}
                onChange={({ name, value }) => handleChange(form, name, value)}
            />
        </GoabFormItem>
    );
};